import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { useSeo } from "../lib/seo";
import { Field, TextInput, FormStatus } from "../components/forms/Fields";

export default function AdminLogin() {
  useSeo("Owner sign in");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState(null);

  const googleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setStatus(null);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dec_admin_token", data.token);
      nav("/admin/dashboard");
    } catch (err) {
      setStatus({ type: "error", title: "Sign in failed", text: errorMessage(err) });
    } finally { setBusy(false); }
  };

  return (
    <section className="bg-cream text-ink py-20 md:py-28">
      <div className="max-w-md mx-auto px-6">
        <p className="lbl text-teal">Owner area</p>
        <h1 className="mt-4 !text-5xl">Sign in</h1>
        <p className="mt-4 text-slate">Review requests, payments, resources and testimonials.</p>
        <div className="mt-10 bg-paper rounded-2xl p-6">
          <button type="button" onClick={googleSignIn} className="w-full inline-flex justify-center items-center gap-3 font-sans border-2 border-ink/80 rounded-full py-3 hover:bg-sky transition-colors" data-testid="admin-google-signin">
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.6 5.4 2.6 13.3l7.8 6C12.3 13.6 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.4c-.5 2.9-2.2 5.3-4.6 7l7.4 5.7c4.3-4 6.9-9.9 6.9-17.2z"/><path fill="#FBBC05" d="M10.4 28.7c-.5-1.4-.8-3-.8-4.7s.3-3.3.8-4.7l-7.8-6C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.7l7.8-6z"/><path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.7c-2.1 1.4-4.8 2.3-8.5 2.3-6.3 0-11.7-4.1-13.6-9.8l-7.8 6C6.6 42.6 14.6 48 24 48z"/></svg>
            Sign in with Google
          </button>
          <p className="mt-3 text-center font-sans text-sm text-slate">Or use your email and password</p>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-6 bg-paper rounded-2xl p-6" aria-label="Owner sign in" data-testid="admin-login-form">
          <Field id="a-email" label="Email" required><TextInput id="a-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Field id="a-password" label="Password" required><TextInput id="a-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
          <button type="submit" disabled={busy} className="w-full inline-flex justify-center items-center gap-2 font-sans bg-teal text-paper rounded-full py-3.5 hover:bg-teal-deep transition-colors" data-testid="admin-login-submit">
            {busy && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}Sign in
          </button>
          <FormStatus status={status} testid="admin-login-status" />
        </form>
      </div>
    </section>
  );
}
